import { render, staticRenderFns } from "./LoginRecordsTable.vue?vue&type=template&id=259622f2&scoped=true&"
import script from "./LoginRecordsTable.vue?vue&type=script&lang=js&"
export * from "./LoginRecordsTable.vue?vue&type=script&lang=js&"
import style0 from "./LoginRecordsTable.vue?vue&type=style&index=0&id=259622f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259622f2",
  null
  
)

component.options.__file = "www/vues/common/loginrecords/LoginRecordsTable.vue"
export default component.exports